import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { Button } from "@/libraries/design/components";
import { ColumnLayout, wacToken } from "@/libraries/design/foundations";
import { RichTextComponent } from "@/libraries/design/utils";

export interface ButtonProps {
    buttonLabel: string;
    buttonHref: string;
}

export interface BottomCallToActionProps {
    title: React.ReactElement<typeof RichTextComponent>;
    emphasisColor?: string;
    body?: React.ReactElement<typeof RichTextComponent>;
    button?: ButtonProps;
}

const containerStyles = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["> div"]: {
        [media.only.sm]: {
            "gridTemplateColumns": "unset",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "> *": {
                gridColumn: "unset"
            }
        }
    },
    backgroundColor: wacToken("color.primary.black"),
    paddingBlock: token("space.800"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["p, h2, h2 > span, h2 > div"]: {
        color: wacToken("color.neutral.light0"),
        textAlign: "center",
        margin: 0
    }
});

const innerContainerStyles = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: token("space.150"),
    [media.above.sm]: {
        paddingBlock: token("space.800")
    }
});

const buttonContainerStyles = css({
    paddingBlockStart: token("space.400")
});

export const BottomCallToAction = ({
    title,
    emphasisColor,
    body,
    button
}: BottomCallToActionProps) => {
    const emphasisStyles = css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["em"]: {
            color: emphasisColor,
            fontStyle: "unset"
        }
    });

    return (
        <div css={containerStyles}>
            <ColumnLayout layout="8">
                <div css={innerContainerStyles}>
                    <h2
                        className="h1-xl"
                        css={[emphasisColor && emphasisStyles]}
                    >
                        {title}
                    </h2>
                    {body ? body : null}
                    {button && (
                        <div css={buttonContainerStyles}>
                            <Button
                                href={button.buttonHref}
                                responsiveSize={{
                                    mobile: "small",
                                    tablet: "large",
                                    desktop: "xlarge",
                                    xl_desktop: "xlarge"
                                }}
                            >
                                {button.buttonLabel}
                            </Button>
                        </div>
                    )}
                </div>
            </ColumnLayout>
        </div>
    );
};
